"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconConvenienceApiServiceImpl = void 0;
const core_1 = require("@athena-portal/core");
const Types_1 = require("../../Types");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const Cache_1 = require("../../decorators/Cache");
const CommonHelpers_1 = require("../../helpers/CommonHelpers");
/**
 * Rest implementation of the example service
 */
let FalconConvenienceApiServiceImpl = class FalconConvenienceApiServiceImpl extends core_1.RestService {
    constructor(configuration, notificationService) {
        super();
        this.configuration = configuration;
        this.notificationService = notificationService;
    }
    analyzeDriversLicenceFront(driversLicenceImage, quoteId) {
        const body = {
            image: driversLicenceImage
        };
        return this.doRequest(`/driver-licence-front?quoteId=${quoteId}`, "POST", body);
    }
    analyzeDriversLicenceBack(driversLicenceImage, quoteId) {
        const body = {
            image: driversLicenceImage
        };
        return this.doRequest(`/driver-licence-back?quoteId=${quoteId}`, "POST", body);
    }
    getRegistrationNumber(vehicleImage) {
        const body = {
            image: vehicleImage
        };
        return this.doRequest("/registration-number", "POST", body);
    }
    getAddressDetailsByPostcodeAndBuilding(partialAddress, limit, offset) {
        return this.doRequest(`/address-lookup-postcode-building?partialAddress=${partialAddress}&limit=${limit}&offset=${offset}`);
    }
    getEalsAddressDetailsByPostcodeAndBuilding(postcode, building) {
        return this.doRequest(`/eals-address-list?postcode=${postcode}&building=${building}`);
    }
    getEalsAddressDetails(addressDetails) {
        return this.doRequest(`/eals-address-details`, "POST", addressDetails);
    }
    getVehicleManufacturerDetails(partialVehicleManufacturer) {
        return this.doRequest(`/vehicle-manufacturer-lookup?${CommonHelpers_1.CommonHelpers.toQueryString({ partialVehicleManufacturer })}`);
    }
    getVehicleModelYears(vehicleManufacturer, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest(`/vehicle-model-years-annual?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer, vehicleShortenedModel: shortenedModel })}`);
        }
        else {
            return this.doRequest(`/vehicle-model-years-annual?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer })}`);
        }
    }
    getVehicleTransmissions(vehicleManufacturer, manufactureYear, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest(`/vehicle-transmissions-annual?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer, manufactureYear, vehicleShortenedModel: shortenedModel })}`);
        }
        else {
            return this.doRequest(`/vehicle-transmissions?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer, manufactureYear })}`);
        }
    }
    getVehicleFuelTypes(vehicleManufacturer, manufactureYear, transmission, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest(`/vehicle-fuel-types-annual?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer, vehicleShortenedModel: shortenedModel, manufactureYear, transmission })}`);
        }
        else {
            return this.doRequest(`/vehicle-fuel-types?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer, manufactureYear, transmission })}`);
        }
    }
    getVehicleEngineSizes(manufacturer, manufactureYear, transmission, fuelType) {
        return this.doRequest(`/vehicle-engine-sizes?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer: manufacturer, manufactureYear, transmission, fuelCode: fuelType })}`);
    }
    getVehicleDoors(manufacturer, manufactureYear, transmission, fuelType, engineSize, shortenedModel) {
        if (shortenedModel) {
            return this.doRequest(`/vehicle-doors-annual?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer: manufacturer, manufactureYear, transmission, fuelCode: fuelType, engineSize, vehicleShortenedModel: shortenedModel })}`);
        }
        else {
            return this.doRequest(`/vehicle-doors?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer: manufacturer, manufactureYear, transmission, fuelCode: fuelType, engineSize })}`);
        }
    }
    getVehicleStyles(manufacturer, manufactureYear, transmission, fuelType, engineSize, doors) {
        return this.doRequest(`/vehicle-styles?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer: manufacturer, manufactureYear, transmission, fuelCode: fuelType, doors, engineSize })}`);
    }
    getVehicleModelDetails(vehicleManufacturer, manufactureYear, transmission, fuelCode, partialVehicleModel) {
        return this.doRequest(`/vehicle-model-lookup?${CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer, manufactureYear, transmission, fuelCode, partialVehicleModel })}`);
    }
    getAnnualVehicleShortenedModelDetails(manufacturer, shortenedModel) {
        const queryParams = CommonHelpers_1.CommonHelpers.toQueryString({ vehicleManufacturer: manufacturer, vehicleShortenedModel: shortenedModel });
        return this.doRequest(`/vehicle-shortened-model-lookup-annual?${queryParams}`);
    }
    getAnnualVehicleModelDetails(manufacturer, manufactureYear, transmission, fuelType, engineSize, doors, style, shortenedModel, model) {
        const queryParams = CommonHelpers_1.CommonHelpers.toQueryString({
            vehicleManufacturer: manufacturer,
            manufactureYear,
            transmission,
            fuelCode: fuelType,
            doors,
            bodyStyle: style,
            vehicleShortenedModel: shortenedModel,
            partialVehicleModel: model,
            engineSize
        });
        return this.doRequest(`/vehicle-model-lookup-annual?${queryParams}`);
    }
    postcodeExists(postcode) {
        return this.doRequest(`/postcode-lookup?postcode=${postcode}`);
    }
    getFurnishingTypeParams() {
        return this.doRequest(`/furnishing-types`);
    }
    getRealEstateTypeSubtypeParams(product) {
        return this.doRequest(`/real-estate-type-subtypes?product=${product}`);
    }
    getCustomerCancellationReasons(product) {
        return this.doRequest(`/customer-cancellation-reasons?product=${product}`);
    }
    getImages(reference) {
        return this.doRequest(`/images?reference=${reference}`);
    }
    deleteImage(reference, imageId) {
        return this.doRequest(`/images/${imageId}?reference=${reference}`, "DELETE");
    }
    deleteByReference(reference) {
        return this.doRequest(`/images?reference=${reference}`, "DELETE");
    }
    postImage(reference, base64, filename) {
        const body = {
            image: base64,
            filename
        };
        return this.doRequest(`/images?reference=${reference}`, "POST", body);
    }
    getSettings() {
        return this.doRequest(`/settings`);
    }
    getAllProductClassifiers(product) {
        return this.doRequest(`/v2/classifier/AllianzRetail/${product}/all`);
    }
    getClassifiers(classifierName, fieldValue) {
        let requestUrl = `/v2/classifier/AllianzRetail/${classifierName}`;
        if (fieldValue !== undefined) {
            requestUrl = requestUrl.concat(`?fieldValue=${fieldValue}`);
        }
        return this.doRequest(requestUrl);
    }
    isQuickerQuoteAvailable() {
        return this.doRequest(`/quicker-quote/available`);
    }
    redirectToQuickerQuote() {
        return this.prepareRedirectUrl("/quicker-quote/redirect");
    }
    prepareRedirectUrl(urlAppend) {
        let url = `${this.configuration.serviceBaseUrl}${urlAppend}`;
        if (this.configuration.customQueryStringParameters) {
            const queryString = core_1.ConfigHelper.mapToQueryString(this.configuration.customQueryStringParameters);
            const separator = url.indexOf("?") === -1 ? "?" : "&";
            url = `${url}${separator}${queryString}`;
        }
        return url;
    }
    doRequest(urlAppend, method, body, onErrorReturn) {
        return super.getProtectedResource({
            body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}${urlAppend}`,
        }, this.configuration.customQueryStringParameters, false).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.of)(onErrorReturn || {});
        }));
    }
};
exports.FalconConvenienceApiServiceImpl = FalconConvenienceApiServiceImpl;
__decorate([
    (0, Cache_1.CacheObservable)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconConvenienceApiServiceImpl.prototype, "getSettings", null);
__decorate([
    (0, Cache_1.CacheObservable)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconConvenienceApiServiceImpl.prototype, "getAllProductClassifiers", null);
__decorate([
    (0, Cache_1.CacheObservable)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconConvenienceApiServiceImpl.prototype, "getClassifiers", null);
exports.FalconConvenienceApiServiceImpl = FalconConvenienceApiServiceImpl = __decorate([
    (0, core_1.injectable)(),
    __param(0, (0, core_1.inject)(Types_1.Types.FalconConvenienceApiServiceConfig)),
    __param(1, (0, core_1.inject)(Types_1.Types.NotificationService)),
    __metadata("design:paramtypes", [Object, Object])
], FalconConvenienceApiServiceImpl);
//# sourceMappingURL=FalconConvenienceApiServiceImpl.js.map